module.exports = __webpack_public_path__ + "static/media/IMG_0082.a42c6459.jpg";